export const API_URL = window.__RUNTIME_CONFIG__.REACT_APP_API_URL
export const UPLOAD_URL = window.__RUNTIME_CONFIG__.REACT_APP_BASE_URL
export const REACT_APP_BASE_URL_FORM = 'https://bpm-form-api.server247.info/api'

// AOF-Xtract document-verification app, loaded in an iframe and talked to over
// postMessage (see dmsModule DocXtractVerifyWidget). Runtime-configurable per
// environment (UAT / Live); falls back to the UAT host when the key is absent.
export const XTRACT_URL =
  window.__RUNTIME_CONFIG__.REACT_APP_XTRACT_URL || 'https://aof-xtract.gibl.com.np:30384'

export const REPORT_DOMAIN = window.__RUNTIME_CONFIG__.REACT_REPORT_DOMAIN
export const DASHBOARD_ID = window.__RUNTIME_CONFIG__.REACT_SUPERSET_DASHBOARD_ID
export const SUPERSET_FIRST_NAME = window.__RUNTIME_CONFIG__.REACT_SUPERSET_FIRST_NAME
export const SUPERSET_LAST_NAME = window.__RUNTIME_CONFIG__.REACT_SUPERSET_LAST_NAME
export const SUPERSET_USERNAME = window.__RUNTIME_CONFIG__.REACT_SUPERSET_USERNAME
